import React from 'react';
import { render } from 'react-dom';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import Root from './containers/Root';
import configureStore from './store/configureStore';
import { authInfo } from './actions/';

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

authInfo(store.dispatch);

render(
  <Root store={store} history={history} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js